export default "__VITE_ASSET__sCSgNIt9__"